import API from './API.js';
export default class MasterKeyStatus extends API {
    constructor() {
        super('master-key-status');
    }

}
